import { PickObjectRecursive } from "@/common/declare";

const dlc = {
	Abandoned:"Invalid ticket",
	Auditing:"To examine",
	ACCOUNTING: "Accounting",
	ACTION: "Action",
	Add: "Add",
	AddAgent: "Add Agent",
	AddArticle: "Add Article",
	AddBanner: "Add Banner",
	AdditionalContact: "Additional Contact",
	ADDITIONALCONTACT: "Additional Contact",
	ADDITIONALDESCRIPTION: "Additional Description",
	address: "Address",
	administrators: "Administrators",
	ADULT: "Adult",
	Agencyrate: "Agency Rate",
	AgentInformation: "Agent Information",
	AIRCRAFT: "Aircraft",
	AIRLINES: "Airlines",
	AIRPORTTAX: "Airport Tax",
	all: "All",
	ALLOW_BAG_SEAT: "Allow bag/Seat",
	amount: "Amount",
	Amount: "Amount",
	ANCILARY: "Ancillary",
	ANCILLARIES: "Ancillaries",
	APPROVEDBY: "Approved by",
	AreYouSure: "Are you sure? ",
	Areyousureseat: "Are you sure to reserve the seat?",
	ARRIVAL: "Arrival",
	AVAILABILITY: "Availability",
	Back: "Back",
	balance: "Balance",
	Balance: "Balance",
	banner: "Banner",
	BasicFare: "Base Fare",
	BIRTHDATE: "Birthdate",
	BOOK: "Book",
	BOOKCODE: "Book Code",
	BOOKDATE: "Book Date",
	BOOKEDBY: "Booked By",
	BOOKINFO: "Booking Info",
	CABIN: "Cabin",
	CALLER: "Caller",
	cancel: "Cancel",
	CancelBook: "Cancel Booking",
	CANCELBOOKING: "Cancel Booking",
	CancelledBasicFare: "Cancelled Base Fare",
	CancelledSurchargeFee: "Cancelled Surcharge Fee",
	CancelledTerminalFee: "Cancelled Terminal Fee",
	cancelorder: "Cancel Order",
	CheckPrice: "Check Price",
	checkURLformat: "Check URL Format",
	CHILD: "Child",
	CLASS: "Class",
	close: "Close",
	Commissionrebate: "Commission Rebate",
	Commissionsharing: "Commission Sharing",
	Companydetails: "Company Details",
	confirm: "Confirm",
	Confirmrefund: "Confirm Refund",
	CONTACT: "Contact",
	ContactInfo: "Contact Information",
	Contactphonenumber: "Contact Number",
	Uploadimages: "Content",
	corporateName: "Corporate Name",
	CREATEBY: "Created by",
	CreateNewBooking: "Create New Booking",
	Createrefundform: "Create Refund Form",
	Creationtime: "Creation Time ",
	Currency: "Currency",
	DATE: "Date",
	Deactivate: "Deactivate",
	Deductionamount: "Amount Deduction",
	delete: "Delete",
	Deleteorder: "Delete Order",
	DEP_ARV: "Departure/Arrival",
	Departure: "Departure",
	DEPARTURE: "Departure",
	DEPARTUREDATE: "Departe Date",
	DepartureRouteInfo: "Departure Route Info",
	Description: "Description",
	DESCRIPTION: "Description",
	DESTINATION: "Destination",
	DESTNATION: "Destination",
	detail: "Detail",
	determine: "Determine",
	Disablearticles: "Disable Articles",
	Disabled: "Disabled",
	DURATION: "Duration",
	edit: "Edit",
	email: "Email",
	Email: "Email",
	Enable: "Enable",
	Enablearticles: "Enable Articles",
	EndofTransaction: "End of Transaction",
	ETicket: "E-ticket",
	expenditure: "Expenditure",
	FARE: "Fare",
	fast: "Fast",
	FEES: "Fees",
	file: "File",
	FIRSTNAME: "First Name",
	FLIGHT: "Flight",
	FLIGHTDATE: "Flight Date",
	FLIGHTNUMBER: "Flight Number",
	global: {
		input_add: "Add",
		input_cancel: "Cancel",
		input_confirm: "Confirm",
		input_copy: "Copy",
		input_disable: "Disable",
		input_edit: "Edit",
		input_enable: "Enable",
		input_export: "Export",
		input_filter: "Filter",
		input_search: "Search",
		input_sync: "Refresh",
		label_nav_create: "Create",
		label_nav_edit: "Edit",
		label_no: "No",
		label_warn: "Hint",
		label_yes: "Yes",
		lang_cn: "Chinese",
		lang_eng: "English",
		msg_copy_success: "Successful Copied",
		msg_post_success: "Successfully Posted",
		ph_all: "All",
		ph_end: "End Date",
		ph_range: "to",
		ph_start: "Start Date",
		require: "Please Enter",
		require_phoneNumber: "Please enter the correct format of phone number",
		fn_localPrice: '{localPrice,0}',
		fn_tYMD: '{timeYMD,0,1,2}',
		fn_tHM: '{timeHM,0,1}',
		fn_tDate: '{formatDate,0}',
	},
	GROUPNAME: "Group Name",
	HandmadePlus: "MANUAL addition",
	home: {
		input_account_hint: "In stock sku/total sku",
		input_login: "Login",
		input_password_hint: "In stock sku/total sku",
		input_remember: "Remember password",
		link_forget: "Forgot your password?",
		link_regist_1: "No Account?",
		link_regist_2: "Register",
		require_account: "Please input account",
		require_password: "Please input password",
		welcome_1: "Welcome to Fanslink CDMS",
		welcome_2: ""
	},
	hotspot: "Hotspot",
	income: "Income",
	INFANT: "Infant",
	INPUTBY: "Input By",
	INPUTDATE: "Input Date",
	INSURANCE: "Fuel Surcharge",
	issuancefailed: "Issuance failed",
	issuedsuccessfully: "Issued Successfully",
	Keberangkatan: "departure",
	LASTNAME: "Last Name",
	Loginaccount: "Login Account",
	macroMutexSelector: "macromutex select",
	Manualdeduction: "Manual Deduction",
	Mobile: "Mobile Number",
	MOBILE: "Phone Number",
	MODIFICATION: "Modify",
	ModifyRefundLimit: "Modify Refund limit",
	MyBookings: "My Bookings",
	name: "Name",
	Name: "Name",
	nationality: "Nationality",
	NATIONALITY: "Nationality",
	NewBooking: "New Booking",
	NEWREFUNDLIMIT: "New Refund Limit",
	No: "No",
	NO: "Normal",
	normal: "Normal",
	notIncomplete: "complete",
	NUMERICCODE: "Numeric Code",
	objective: "Objective",
	OddNumbers: "Order number",
	OFFICE: "Office",
	open: "Open",
	operation: "Operate",
	Ordercompleted: "Order Complete",
	Orderrefund: "Order Refund",
	ORIGIN: "Origin",
	ORNUMBER: "OR Number",
	OTHERFEE: "Other Fee",
	Otherrefunds: "Other Refunds",
	OUTSTANDING: "Amount",
	pagination: {
		label_total: "Total (0) per page"
	},
	PASSENGER: "Passenger",
	PassengerInfo: "Passenger Information",
	PASSENGERNAME: "Passenger Name",
	PASSENGERS: "Passengers",
	PASSPORT: "Passport",
	PASSPORTEXPDATE: "Passport Expiry Date",
	PASSPORTEXPIRYDATE: "Passport Expiry Date",
	PASSPORTNUMBER: "Passport Number",
	password: "Password",
	PAX: "Passenger",
	PaxInfo: "Passenger Info",
	PAXTYPE: "Passenger Type",
	Payment: "Payment",
	PAYMENT: "Payment",
	PaymentHistory: "Payment History",
	PaymentOrder: "Payment Order",
	Pendingrefund: "Pending Refund",
	Pendingreview: "Pending Review",
	phone: "Phone Number",
	picture: "Picture",
	Pleaseamount: "amount refund",
	PleaseConfirm: "Confirm",
	Pleaseenter: "Enter",
	pleasefeeslist: "confirm fees list",
	pleasereason: "confrim reason",
	Pleaseupload: "Upload",
	PREPAIDBAGGAGE: "Prepaid Baggage",
	PreviousBalance: "Previous Balance",
	PRINTBOOKING: "Print Booking",
	Printltinerary: "Print All in 1 Itinerary",
	PRINTPNR: "Print PNR",
	PrintSMTicket: "Print SM Ticket",
	PRMOMCODE: "Promo Code",
	prompt: "Prompt",
	PULANGPERGI: "PULANG PERGI",
	query: "Query",
	reason: " Reason",
	REASON: "Reason",
	ReBookFee: "Rebooking Fee",
	RebookInfo: "Rebook Info",
	Recharge: "Recharge",
	Rechargedetails: "Recharge Details",
	Rechargerecords: "Recharge Records",
	Refund: "Refund",
	REFUND: "Refund",
	RefundableAmount: "Refundable Amount",
	REFUNDABLES: "Refundables",
	refundamount: "Refund Amount",
	Refundcompleted: "Refund Completed",
	Refundfailed: "Refund Failed",
	RefundFee: "Refund Fee",
	RefundLimit: "Refund Limit",
	Refusalrefund: "Refund Not allowed",
	refuse: "Refuse",
	region: "Region",
	Remarks: "Remarks",
	ReprintReceipt: "Reprint Receipt",
	RESERVESEAT: "Reserve Seat",
	Restrictsales: "Restrict Sales",
	Returndate: "Return Date",
	role: "Role",
	ROUTE: "Route",
	RouteInfo: "Route Info",
	SATUARAH: "One-way",
	SEAT: "Seat",
	Seatfailed: "Seat Failed",
	SeatReserved: "Seat Reserved",
	seatsuccessful: "Seat Successful",
	Selectendtime: "End Time",
	Selectstarttime: "Start Time",
	SERVICEDAY: "Service Day",
	ShowRemarksInfo: "Show Remarks Information",
	sort: "Sort",
	state: "State",
	STATUS: "Status",
	SURCHARGE: " Surcharge Fee",
	SurchargeFee: "Surcharge Fee",
	surplus: "Surplus",
	TCP: "TCP (the complete party)",
	TerminalFee: "Terminal Fee",
	TERMINALFEE: "Terminal Fee",
	TICKETING: "Ticketing",
	ticketNo: "Ticket Number",
	TICKETNUMBER: "Ticket Number",
	time: "Time",
	TIMELIMIT: "Time Limit",
	title: "Title",
	TITLE: "Title",
	TKTNUMBER: "Ticket Number",
	tocontinue: "Continue",
	TopUp: "Top up",
	TOTAL: "Total",
	Totalcost: "Total Cost",
	TotalPreviousPayment: "Total Previous Payment",
	TOTALPRICE: "Total Price",
	TRAMSIT: "Transit",
	TRANSACTIONDATE: "Transaction Date",
	TRANSIT: "Transit",
	Turnoffhotspot: "Turn off Hotspot",
	Turnonhotspot: "Turn on Hotspot",
	type: "Type",
	uac: {
		enum_invalid: "Invalid",
		enum_valid: "Valid",
		input_cancle: "Cancel",
		input_confirm: "Confirm",
		input_create: "Add Department",
		input_del: "Delete",
		label_add: "Add",
		label_add_part: "Add Departments",
		label_delete_depart: "Delete Department",
		label_delete_role: "Delete Role",
		label_delete_user: "Delete User",
		label_department: "Affiliated Department",
		label_edit: "Edit",
		label_edit_part: "Edit Departments",
		label_email: "Employee Email",
		label_employeeId: "Employee ID",
		label_login: "Login",
		label_menu: "Menu",
		label_mobile: "Employee Phone Number",
		label_name: "Employee Name",
		label_partname: "Department Name ",
		label_password: "Password",
		label_remark: "Remarks",
		label_repeat_password: "Repeat password",
		label_role: "User Role",
		label_roleName: "Role Name",
		label_warn: "Warning",
		ph_depart: "Department",
		ph_role: "Role",
		ph_userName: "Username",
		require_doublepassword: "Re-type Password",
		require_employeename: "Enter employee name",
		require_employeenumber: "Enter employee number",
		require_nomatch_password: "Password do not match",
		require_password: "Enter Password",
		require_select_role: "Enter User role",
		require_username: "Enter Username",
		th_authType: "Role Type",
		th_createTime: "Create Time ",
		th_depart: "Department",
		th_email: "Email",
		th_mobile: "Mobile Number",
		th_nums: "Total number of users",
		th_oparate: "Operate",
		th_partname: "Department Name ",
		th_remark: "Remarks",
		th_roleName: "Role Name",
		th_sharp: "",
		th_status: "Status",
		th_userName: "Username"
	},
	Unavailable: "Unavailable",
	UpdateAgent: "Update Agent",
	UpdateArticle: "Update Article",
	UpdateBanner: "Update Banner",
	content: "Upload Image",
	user: "User",
	Userapplication: "User Application",
	USERID: "User ID",
	VALID: "Valid ",
	VALIDDATE: "Valid Date",
	VALIDTY: "Validity",
	VAT: " VAT",
	VIEWPNR: "View PNR",
	VIEWSCHEDULE: "View Schedule",
	warehouse: {
		channel: {
			ph_search_channelwhs: "Please enter the name of the channel warehouse",
			th_channel: "Sales Channel",
			th_checkin: "Waiting to enter the warehouse",
			th_freezed: "Freezed Stock",
			th_mark: "Remarks",
			th_name: "Channel Location",
			th_number: "",
			th_realwhs: "The entity warehouse to which it belongs",
			th_skuRatio: "In stock sku/total sku",
			th_sold: "Historical Sales Volume"
		},
		enum_disable: "Disable",
		enum_normal: "Normal",
		input_cancel: "Cancel",
		input_create: "Create",
		label_cancelTime: "Cancel",
		label_mark: "Remarks",
		ph_datePicker_end: "End Date",
		ph_datePicker_range: "to",
		ph_datePicker_start: "Start Date",
		real: {
			ph_search_realwhs: "Please enter the name of the physical warehouse",
			th_address: "Warehouse Address",
			th_channelRef: "Channel Location",
			th_checkin: "Waiting To Enter The Warehouse",
			th_contact: "Warehouse Contact",
			th_freezed: "Freezed Inventory",
			th_name: "Physical Warehouse",
			th_number: "",
			th_skuRatio: "In stock sku/total sku",
			th_sold: "Historical Sales Volume"
		},
		td_del: "Delete",
		td_edit: "Edit",
		th_oper: "Operation",
		th_state: "Status",
		warn_noSel: "Please select an item first"
	},
	Yes: "Yes",
	Agentcode: "Agent code",
	Agentlist: "AGENT LIST",
	Reductions:"Transfer accounts",
	Transferin:"Transfer in",
	Transferout:"Transfer out",
	operate:"Operate",
	Resendticket: "Resend electronic ticket",
	travelTax: "Travel fee",
	webFee: "Order service fee",
	flightawaiting: "Successfully deleted flight segment, awaiting review",
	flightFailed: "Failed to delete flight segment",
	pnrawaiting: "Delete PNR successfully, awaiting review",
	pnrdeletion: "PNR deletion failed",
	Invalidticketfailed: "Invalid ticket failed",
	Pendingpayment: "Pending payment",
	Flowtype: "Flow type",
	Businesstype: "Business type",
	Uploadfiles: "Upload files",
	CancelTime: "Cancel Time",
	agent: "Agent",
	subagent: "Subagent",
	RETURN:'RETURN',
	ADDCITY:'ADD CITY',
	MULTICITY:"MULTICITY",
	ReturningRouteInfo:"Returning Route Info",
	PriceInfo:"Price Info",
	NEXT:"NEXT",
	TYPE:"TYPE",
	SPECIALASSISTANCEREQUIRED:"SPECIAL ASSISTANCE REQUIRED",
	areaCode:"Country Code",
	SSRS:'SSRS',
	PRICE:"PRICE",
	Pleaseselectrefund:"Please select the flight segment for ticket refund",
	Pleaseprovidecomplete:"Please provide complete",
	Orderexceedslimit:'Order exceeds limit',
	NonRefundable:'Non-Refundable',
	Expiredthevalidityperiod:'Expired the validity period',
	seatNum:'Number of seats',
	Pleaseselect:'Please select',
	Pleasereschedulingdate:'Please select a rescheduling date',
	Pleaserescheduleflightsegment:'Please choose to reschedule the flight segment',
	Cannotbechanged:'Cannot be changed',
	Areyousuretodelete:'Are you sure to delete?',
	cannotrefunded:'This flight cannot be refunded',
	operator:'Operator',
	Pleaseenteryouremailaddress:'Please enter your email address',
	refreport:'REF REPORT',
	salreport:'SAL REPORT',
	uplreport:'UPL REPORT',
	Actualtakeoffstarttime:'Takeoff start time',
	Actualtakeoffendtime:'Takeoff end time',
	Doistarttime:'Doi start time',
	Doiendtime:'Doi end time',
	Plannedarrivalendtime:'Planned arrival end time',
	Pleaseselectstartandenddates:'Please select start and end dates',
	PleaseselectDoitakeofftime:'Please select Doi start and end time or takeoff start and end time',
	noshowreport:'NOSHOW REPORT',
	UndefinedReport:'UNDEFINED REPORT',
	imageuploadTypeTip:'Only images can be uploaded',
	imageuploadSizeTip:'The image size cannot exceed 2MB',
	// localization functions
	_f: {
		localPrice: (price: number) => {
			if (typeof price !== 'number') {
				return '';
			}

			let minus = price < 0;
			let price100x = Math.abs(Math.floor(price * 100 + 0.5));

			const floatPart = price100x % 100
			price100x = Math.floor(price100x / 100);

			const intPart: string[] = [];

			while (price100x > 999) {
				intPart.unshift((price100x % 1000).toString().padStart(3, '0'));
				price100x = Math.floor(price100x / 1000);
			};

			intPart.unshift(price100x.toString());
			return `${minus ? '-' : ''}${intPart.join(',')}.${floatPart.toString().padStart(2, '0')}`;
		},
		timeYMD: (y: number, mn: number, d: number) => {
			const formatNumber = dlc._f.formatNumber;
			return `${y}-${formatNumber(mn)}-${formatNumber(d)}`;
		},
		timeHM: (h: number, m: number) => {
			const formatNumber = dlc._f.formatNumber;
			return `${formatNumber(h)}:${formatNumber(m)}`;
		},
		formatDate: (date: Date) => {
			const formatNumber = dlc._f.formatNumber;
			const y = date.getFullYear();
			const mn = formatNumber(date.getMonth() + 1);
			const d = formatNumber(date.getDate());
			const h = formatNumber(date.getHours());
			const m = formatNumber(date.getMinutes());
			const s = formatNumber(date.getSeconds());

			return `${y}-${mn}-${d} ${h}:${m}:${s}`;
		},
		formatNumber: (n: number) => {
			return n.toString().padStart(2, '0')
		}
	}
}

export type LangNspEn = PickObjectRecursive<typeof dlc>

export default { dlc };